/**
 * Hooks spécialisés pour les permissions sur les locations
 */
import { useMemo } from 'react';
import { useMultipleAuthorizations } from './useAuthorization';
import { ActionType, ModelType } from '@constants/authorization';

/**
 * Hook pour toutes les permissions sur une location
 */
export const useLocationPermissions = (locationId) => {
  const checks = useMemo(() => {
    if (!locationId) {
      return [];
    }

    const permissionChecks = [
      { key: 'canUpdate', action: ActionType.UPDATE, modelType: ModelType.LOCATION, modelId: locationId },
      { key: 'canDelete', action: ActionType.DELETE, modelType: ModelType.LOCATION, modelId: locationId }
    ];

    return permissionChecks;
  }, [locationId]);

  const { permissions, loading, error, refresh } = useMultipleAuthorizations(checks);

  return {
    permissions: {
      canUpdate: permissions.canUpdate || false,
      canDelete: permissions.canDelete || false
    },
    loading,
    error,
    refresh
  };
};

/**
 * Hook pour les permissions de création de locations
 */
export const useLocationCreationPermission = () => {
  const checks = useMemo(() => [
    { key: 'canCreate', action: ActionType.CREATE, modelType: ModelType.LOCATION }
  ], []);

  const { permissions, loading, error, refresh } = useMultipleAuthorizations(checks);

  return {
    canCreate: permissions.canCreate || false,
    loading,
    error,
    refresh
  };
};
